<template>
  <div class="aside">
    <changerole></changerole>
    <el-menu router @select="handleSelect">
      <el-menu-item
        :class="$route.path == '/MS/MSinterview' ? 'is-active' : ''"
        index="/MS/MSinterview"
      >
        <el-tooltip placement="right" effect="light" popper-class="atooltip">
          <div slot="content">投稿<br />学员</div>
          <img src="../../assets/icon/投稿学员icon.png" class="iconmenu" />
        </el-tooltip>
      </el-menu-item>
      <el-menu-item
        :class="$route.path == '/MS/MSmeet' ? 'is-active' : ''"
        index="/MS/MSmeet"
      >
        <el-tooltip placement="right" effect="light" popper-class="atooltip">
          <div slot="content">会议<br />管理</div>
          <img src="../../assets/icon/会议管理icon.png" class="iconmenu" />
        </el-tooltip>
      </el-menu-item>
    </el-menu>
    <div class="back">
      <img
        src="../../assets/icon/退出.png"
        class="icon"
        @click="logout"
        height="20px"
        width="20px"
      />
    </div>
  </div>
</template>

<script>
import axios from '../axios'
import { MessageBox } from 'element-ui'
import changerole from '../pub/changerole'
export default {
  name: 'msnav',
  components: { changerole },
  methods: {
    handleSelect (key, keyPath) {
      this.$router.replace({ path: `${keyPath}` })
    },
    logout () {
      MessageBox.confirm('是否注销？')
        .then(() => {
          axios.delete('/logout').then(() => {
            localStorage.removeItem('Authorization')
            this.$router.replace('/login')
          })
        })
        .catch(() => {})
    }
  }
}
</script>
